import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * 페이지 파라미터가 변경될 때마다 스크롤을 상단으로 이동시키는 훅
 * @param {string} pageParamName - 페이지 파라미터 이름 (기본값: 'page')
 * @param {number} delay - 스크롤 실행 전 지연 시간 (기본값: 100ms)
 */
export const useScrollToTopOnPageChange = (pageParamName = 'page', delay = 50) => {
  const [searchParams] = useSearchParams();
  const currentPage = searchParams.get(pageParamName);

  useEffect(() => {
    // 페이지 파라미터가 존재하고 변경되었을 때만 스크롤 이동
    if (currentPage) {
      // DOM이 완전히 렌더링된 후 스크롤 최상단으로 이동
      const timer = setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: 'auto',
        });
      }, delay);

      return () => clearTimeout(timer);
    }
  }, [currentPage, delay]);
};
